import axios from './axiosConfig';
import moment from 'moment';
let ajaxCount = 0;

export const setTabContentTo = ({ tab, container = window, executeBeforeTabLoad = false, target, url, anchor, cancelToken, pushState }) => {
  const { tabId } = tab.dataset;
  setActiveTabLink(tab);
  target.innerHTML = App.spinner();
  executeBeforeTabLoad && App.beforeTabLoad && App.beforeTabLoad(tabId);
  return xhrRequest(App.Helpers.noCacheURL(url), 'get', {}, cancelToken)
    .then(res => {
      target.innerHTML = res.data;
      if (pushState) {
        window.history.pushState(null, null, url);
      }
      App.initializeTabContent && App.initializeTabContent(tabId);
      anchor && animateToElementInContainer({ container, destination: document.getElementById(anchor) });
      return res;
    }).catch(catchRequestCancel);
};

const setActiveTabLink = link => {
  const linkContainer = link.closest('li');
  [...document.querySelectorAll('.tab-li')].forEach(li => {
    li.className = (li === linkContainer ? 'active ' : '') + 'tab-li'
  });
};

export const getAjaxCount = () => ajaxCount;

export const formSerializer = form => {
  const inputs = [].slice.call(form.querySelectorAll("input:not([type='checkbox']), select, textarea"));
  const checkboxes = [].slice.call(form.querySelectorAll("input[type='checkbox']"));
  return checkboxes.reduce((obj, checkbox) => (
    checkbox.name ? { ...obj, [checkbox.name]: checkbox.checked } : obj
  ), inputs.reduce((obj, element) => (
    element.name ? { ...obj, [element.name]: element.value } : obj
  ), {}));
};

export const cancelToken = () => axios.CancelToken.source();

export const catchRequestCancel = err => {
  if (axios.isCancel(err)) {
    console.log('Request canceled');
  } else {
    return err;
  }
};

export const xhrRequest = async (url, method, data, cancelToken) => {
  const csrfTokenTag = document.querySelector('meta[name=csrf-token]')
  ajaxCount++
  return axios(url, {
    cancelToken: cancelToken ? cancelToken.token : null,
    method: method.toUpperCase(),
    data: {
      ...data,
      _method: method.toLowerCase
    },
    headers: {
      'X-CSRF-Token': csrfTokenTag ? csrfTokenTag.content : null
    }
  }).then(res => {
    ajaxCount--
    return res
  });
}

export const afterXhrRequest = response => {
  if (response && response.headers) {
    const xMessageType = response.headers['x-message-type']
    if (xMessageType && xMessageType !== 'empty') {
      const xMessage = response.headers['x-message']

      // From asset pipeline...
      App.FlashAlerts.renderAlert(xMessage, xMessageType === 'alert' ? 'danger' : xMessageType)
    }
  }
  return response;
}

export const infoDialogBox = content => (
  ` <div class="info-triangle"></div>
    <div class="info-content">
      ${content}
    </div>`
)

export const animateToElementInContainer = ({ container = window, destination, milliseconds = 500 }) => {
  const startPoint = container === window ? container.pageYOffset : container.scrollTop
  const endPoint = getElementYCoordinate(destination)
  const distance = endPoint - startPoint

  const animateStep = (timestamp, start=null) => {
    if (!start) start = timestamp
    const time = timestamp - start
    const percent = Math.min(time / milliseconds, 1)

    const newScrollTop = startPoint + distance * percent
    container === window ? container.scrollTo(0, newScrollTop) : (container.scrollTop = newScrollTop)

    time < milliseconds && window.requestAnimationFrame(ts => animateStep(ts, start))
  }
  window.requestAnimationFrame(animateStep)
}

export const animateTo = (destination, milliseconds=500) => {
  animateToElementInContainer({ destination, milliseconds })
}

export const adjustStickyHeader = ({ elementTop, elementBottom, element, width = null, elementToPush = null }) => {
  if (!element) return
  if (window.scrollY >= elementTop && window.scrollY <= elementBottom) {
    if (!element.classList.contains('sticky')) {
      width && (element.style.width = `${width}px`)
      element.classList.add('sticky')
    }
  } else {
    if (element.classList.contains('sticky')) {
      element.classList.remove('sticky')
    }
  }
}

export const customPolyfills = () => {
  // Polyfill for matches()
  if (!Element.prototype.matches)
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                Element.prototype.webkitMatchesSelector;

  if (!document.createElementFromString) {
    document.createElementFromString = (htmlStr, parentType='div') => {
      const div = document.createElement(parentType);
      div.innerHTML = htmlStr.trim();
      return div.firstChild
    }
  }

  // Polyfill for closest()
  if (!Element.prototype.closest)
    Element.prototype.closest = function(s) {
        var el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };

  // Polyfill for remove()
  [Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach(item => {
    if (item.hasOwnProperty('remove')) return;
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable:  true,
      value: function remove() {
        if (this.parentNode !== null) this.parentNode.removeChild(this)
      }
    })
  })

  if (!Object.entries) {
    Object.entries = obj => {
      var ownProps = Object.keys( obj ),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array
      while (i--)
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
      return resArray;
    }
  }

  if (!Object.sliceKeys)
    Object.sliceKeys = (obj, keys = []) => keys.reduce((newObj, key) => ({ ...newObj, [key]: obj[key] }), {})

  if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(search, this_len) {
      if (this_len === undefined || this_len > this.length) {
        this_len = this.length;
      }
      return this.substring(this_len - search.length, this_len) === search;
    };
  }

  if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  (function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('prepend')) {
        return;
      }
      Object.defineProperty(item, 'prepend', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function prepend() {
          var argArr = Array.prototype.slice.call(arguments),
            docFrag = document.createDocumentFragment();

          argArr.forEach(function (argItem) {
            var isNode = argItem instanceof Node;
            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
          });

          this.insertBefore(docFrag, this.firstChild);
        }
      });
    });
  })([Element.prototype, Document.prototype, DocumentFragment.prototype]);

  document.contains = Element.prototype.contains = Node.prototype.contains = function(node) {
    do {
      if (this === node) return true
      node = node.parentNode
    } while (node)
    return false
  }

  if (!(typeof window.CustomEvent === "function")) {
    function CustomEvent ( event, params ) {
      params = params || { bubbles: false, cancelable: false, detail: null };
      var evt = document.createEvent( 'CustomEvent' );
      evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
      return evt;
    }
    window.CustomEvent = CustomEvent;
  }
}

const getElementYCoordinate = el =>
  el ? (el.offsetTop + (el.offsetParent && el.offsetParent !== document.body ? getElementYCoordinate(el.offsetParent) : 0)) : 0

export const isScrollable = el => el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth

export const displayMoreFlag = el => {
  if ( el.constructor === Array || el.constructor.name === 'NodeList' ) {
    [...el].forEach( scrollableEl => displayFlag(scrollableEl) );
  } else {
    displayFlag(el);
  }
}

const displayFlag = el => {
  const moreDiv = document.createElement('div')
  moreDiv.className = 'more'
  const more = el.appendChild(moreDiv)
  if ( isScrollable(el) ) {
    more.style.opacity = 1
    more.style.zIndex = 10
    // Add scroll event so we can dismiss the flag
    el.addEventListener('scroll', el => {
      more.style.opacity = 0
      more.style.zIndex = -1
    });
  }
}

export const getMonthFromDate = (date, locale = 'en-us') => date.toLocaleString(locale, { month: 'long' })

export const getWeekRange = ({ date, number = 1, showWeekends }) => {
  const dayShift = showWeekends ? 0 : 1
  const firstDate = moment(date).startOf('week').add(dayShift, 'days')
  const secondDate = moment(date).endOf('week').subtract(dayShift, 'days').add(number - 1, 'weeks')
  return {
    firstMonth:   firstDate.format('MMM'),
    secondMonth:  secondDate.format('MMM'),
    firstDay:     firstDate.format('D'),
    secondDay:    secondDate.format('D')
  }
}

const toggleComplete = ({ type, obj, url, successHandler }) => {
  const { complete } = obj
  xhrRequest(url, 'put', {
    [type]: { complete: !complete }
  }).then(({ data }) => successHandler && successHandler(data))
}

export const toggleTaskComplete = ({ task, successHandler }) => {
  toggleComplete({ type: 'task', obj: task, url: task.url, successHandler })
}

export const toggleMilestoneComplete = ({ milestone, successHandler }) => {
  toggleComplete({ type: 'milestone', obj: milestone, url: milestone.url, successHandler })
}

export const minutesToHoursMinutesString = minutes => {
  const absMinutes = Math.abs(minutes)
  const _hours = Math.floor(absMinutes / 60)
  let _minutes = absMinutes % 60
  _minutes < 10 && (_minutes = `0${ _minutes }`)
  return `${minutes < 0 ? '-' : ''}${ _hours }:${ _minutes }`
}

export const timeRangeDisplay = (startAt, endAt) => {
  const start = moment(startAt)
  const end = moment(endAt)
  const showBothMeridiem = start.format('a') !== end.format('a')
  return start.format(`h:mm${showBothMeridiem ? 'a' : ''}`) + ' - ' + end.format('h:mma')
}

export const datesAreEqual = (d1, d2) => d1 && d2 && moment(d1).isSame(moment(d2), 'day')

export const taskDateDisplayClass = date => moment(date).isBefore(moment(new Date()), 'day') ? 'overdue' : ''

export const taskDateFormat = date => moment(date).format('MMM DD YYYY')

export const capitalize = str => (str.charAt(0).toUpperCase() + str.slice(1))

export const splitAndCapitalize = str => str.split(/(?=[A-Z])/).map(st => capitalize(st)).join(' ')

export const paginate = (collection, { perPage = 4, page = 1 } = {}) => {
  const endIndex = perPage * page
  return collection.slice(endIndex - perPage, endIndex)
}

export const closePopoverAfterOffClick = ({ condition = true, elements = [], target, handler }) => {
  condition &&
    document.contains(target) &&
    elements
      .filter(el => !!el)
      .reduce((cond, element) => cond && element !== target && !element.contains(target), true) &&
    handler()
}

export const centsToDollarsCentsString = cents => {
  const reverseArray = Math.floor(cents / 100).toString().split('').reverse()
  const dollarString = reverseArray.reduce((arr, digit, i) => (
    arr.concat((i + 1) % 3 === 0 && reverseArray.length > i + 1 ? [digit, ','] : [digit])
  ), []).reverse().join('')
  return `$${dollarString}`
}

export const toCamelCase = (str, capitalizeFirst = false) => {
  const strArray = str.split(/\s+/).filter(s => s).map(s => s.toLowerCase())
  const capitalizedArray = [strArray[0]].concat(strArray.slice(1).map(el => capitalize(el)))
  const newStr = capitalizedArray.join('')
  return capitalizeFirst ? capitalize(newStr) : newStr
}

export const compareStrings = (str1, str2) => {
  if (str1 === str2) return 0
  if (!str1) return 1
  if (!str2) return -1
  return str1.localeCompare(str2)
}

export const compareNumbers = (num1, num2) => {
  if (num1 === num2) return 0
  if (num1 > num2) return 1
  return -1
}

export const eventIsMultiDay = event => !moment(event.start_at).isSame(moment(event.end_at), 'day')

export const eventIsOnDay = (event, time) => {
  const startAt = moment(event.start_at)
  const endAt = moment(event.end_at)
  const mTime = moment(time)
  return startAt.isSameOrBefore(mTime, 'day') && endAt.isSameOrAfter(mTime, 'day')
}

export const compareEventPositions = (e1, e2) => {
  if (e1.position === e2.position) return 0
  if ((e1.position && !e2.position) || e1.position < e2.position) return -1
  return 1
}

export const compareStartTimes = (e1, e2) => {
  const start1 = moment(e1.start_at)
  const start2 = moment(e2.start_at)
  if (start1.isSame(start2, 'minute')) return 0
  if (start1.isBefore(start2, 'minute')) return 1
  return -1
}

export const editURL = url => {
  const urlComponents = url.split('?');
  return `${urlComponents[0]}/edit?${urlComponents[1] || ''}`;
}

export const createCustomEvent = (name, el, detail={}) => new CustomEvent(name, { detail: { ...detail, el } });

export const dispatchCustomEvent = (name, el, detail={}) => {
  const event = createCustomEvent(name, el, detail)
  return document.dispatchEvent(event) ? event : false
}

export const importAll = r => r.keys().forEach(r);

export const updateParamFor = (url, key, value) => {
  const urlObj = new URL(url)
  urlObj.searchParams.set(key, value)
  return urlObj.href
}



// WEBPACK FOOTER //
// ./app/javascript/shared/helpers.js